import { Injectable } from '@angular/core'
import {
  HttpClient
} from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  url: string | null = null
  sideUrl: string | null = null
  responseOne: Observable<any> | null = null
  responseTwo: Observable<any> | null = null
  constructor (private http: HttpClient) {
    this.url = environment.baseApiUrl + 'admin/'
    this.sideUrl = this.getSide() + 'admin/'
  }

  getSide () {
    if (
      localStorage.getItem('title') &&
      localStorage.getItem('title') === 'Test'
    ) {
      // return 'http://localhost:8080/v1/';
      return 'https://test.icashremit.com/v1/'
    }
    return 'https://api.icashremit.com/v1/'
    // return 'http://localhost:8000/v1/';
  }

  get () {
    return this.http
      .get(
        environment.production
          ? environment.baseApiUrl + 'admins'
          : environment.baseApiUrlTest + 'admins'
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  getAdmin (slug: string): Observable<any> {
    return this.http
      .get(
        environment.production
          ? environment.baseApiUrl + 'admindetails/' + slug
          : environment.baseApiUrlTest + 'admindetails/' + slug
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  filter (data: any): Observable<any> {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'admins/filter'
          : environment.baseApiUrlTest + 'admins/filter',
        data
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  getDetails () {
    return this.http
      .get(
        environment.production
          ? environment.baseApiUrl + 'details/'
          : environment.baseApiUrlTest + 'details/'
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  addAdmin (data: any): Observable<any> {
    this.responseOne = this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'admin/register'
          : environment.baseApiUrlTest + 'admin/register',
        data
      )
      .pipe(
        map((response: any) => {
          return response
        })
      )
    // this.responseTwo = this.http.post(this.sideUrl + 'admin/register', data).pipe(
    //   map(
    //     (response: any) => {
    //       return response;
    //     }
    //   )
    // );
    // return forkJoin([this.responseOne, this.responseTwo]);
    return this.responseOne
  }

  updateAdmin (data: any): Observable<any> {
    return (this.responseOne = this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'admin/update'
          : environment.baseApiUrlTest + 'admin/update',
        data
      )
      .pipe(
        map((response: any) => {
          return response
        })
      ))
  }

  updateAdminTest (data) {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'admin/update'
          : environment.baseApiUrlTest + 'admin/update',
        data
      )
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }

  // updateAdmin(data) {

  //   this.http.post('https://test.icashremit.com/v1/admin/' + 'admin/update', data).pipe(
  //     map(
  //       (response: any) => {
  //         return response;
  //       }
  //     )
  //   );

  //    return this.http.post(this.url + 'admin/update', data).pipe(
  //     map(
  //       (response: any) => {
  //         return response;
  //       }
  //     )
  //   );
  // }

  changeStatus (data) {
    this.responseOne = this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'admin/status'
          : environment.baseApiUrlTest + 'admin/status',
        data
      )
      .pipe(
        map((response: any) => {
          // console.log(data);
          return response
        })
      )

    // this.responseTwo = this.http.post(this.sideUrl + 'admin/status', data).pipe(
    //   map(
    //     (response: any) => {
    //       return response;
    //     }
    //   )
    // );
    // return forkJoin([this.responseOne, this.responseTwo]);
    return this.responseOne
  }

  existsEmail (email) {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'admin/email_exist'
          : environment.baseApiUrlTest + 'admin/email_exist',
        email
      )
      .pipe(
        map((response: any) => {
          return response['status']
        })
      )
  }

  getReconciliation (slug?: string): Observable<any> {
    const path = slug ? 'reconciliation/' + slug : 'reconciliation'
    return this.http
      .get(
        environment.production
          ? environment.baseApiUrl + path
          : environment.baseApiUrlTest + path
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  adjustAgentBalance (data: any): Observable<any> {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'agent/adjust-balance'
          : environment.baseApiUrlTest + 'agent/adjust-balance',
        data
      )
      .pipe(
        map((response: any) => {
          return response
        })
      )
  }
}
